export default __webpack_public_path__ + "static/media/jepygq-x5.332e887f.png";